export const pole = {
	/**
	* Gets the programmatic name of the entire locale, with the language,
	*	country and variant separated by underbars. The Language is always lower case,
	*	and country is always upper case. If the language is missing,
	*	the string will begin with an underscore character.
	*	If both the language and country fields are missing,
	*	this function will return the empty string,
	*	even if the variant field is filled in (you cannot have a locale with just a variant--
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        pole:'Pole',
        pole_no:'Pole No',
        pole_information:'Pole Information',
        pole_id:'Pole Id',
        pole_management:'Pole Management',
        add_pole:'Add Pole',
        edit_pole:'Edit Pole',
        pole_name:'Pole Name',
        status:'Status',
        sno:"Sno",
        area_locality:"Area/Locality",
        ward_sector_no:"Ward/Sector No",
        road_name_Number:"Road Name/Number",
        lane_no:"Lane No",
        pole_number:"Pole Number",
        pole_colour:"Pole Colour",
        pole_height:"Pole Height",
        pole_material	:"Pole Material",
        arm_length:"Arm Length",
        arm_shape	:"Arm Shape",
        arm_diameter:"Arm Diameter",
        arm_thickness:"Arm Thickness",
        arm_inclination:"Arm Inclination",
        foundation_type:"Foundation Type",
        longitude:"Longitude",
        longitude_direction	:"Longitude Direction",
        latitude:"Latitude",
        latitude_direction:"Latitude Direction",
        feeder_panel_number:"Feeder Panel Number",
        feeder_panel_phase:"Feeder Panel Phase",
        earthing_available:"Earthing Available(Y/N)",
        p_l_n_voltage:"P/L-N Voltage",
        n_e_voltage:"N-E Voltage",
        number_of_lamps_pole:"Number of Lamps/Pole",
        ilm_or_glm:"ILM or GLM",
        pole_infrastructure_improvement_is_required:"Pole Infrastructure Improvement is Required(y/n)",
        allow_to_capture_multipe_images_pole_existing_lamp:"Allow to capture multipe images pole & existing lamp",
        existing_type_of_load:"Existing Type of Load",
        wattage_of_existing_load:"Wattage of Existing Load",
        delete_confrim_msg:"Are you sure you want to delete this pole?",
        nominal_existing_load_wattage_for_energy_savings:"Nominal Existing Load Wattage for energy savings",
        poles:"poles"
    },

    ar: {
        pole:' العمود',
        pole_no:'رقم العمود',
        pole_information:'معلومات العمود',
        pole_id:'معرف العمود',
        pole_management:'إدارة العمود',
        add_pole:'أضف العمود',
        edit_pole:'تحرير العمود',
        pole_name:'اسم العمود',
        status:'الحالة',
        sno:"Sno",
        area_locality:"المنطقة",
        ward_sector_no:"رقم الجناح / القطاع",
        road_name_Number:"اسم / رقم الطريق",
        lane_no:"رقم الممر",
        pole_number:"رقم العمود",
        pole_colour:"لون العمود",
        pole_height:"ارتفاع العمود",
        pole_material	:"مادة العامود",
        arm_length:"طول الذراع",
        arm_shape	:"شكل الذراع",
        arm_diameter:"قطر الذراع",
        arm_thickness:"سماكة الذراع",
        arm_inclination:"ميل الذراع",
        foundation_type:"نوع الأساس",
        longitude:"خط الطول",
        longitude_direction	:"اتجاه خط الطول",
        latitude:"خط العرض",
        latitude_direction:"اتجاه خط العرض",
        feeder_panel_number:"رقم لوحة التغذية",
        feeder_panel_phase:"مرحلة لوحة التغذية",
        earthing_available:"التأريض متاح (نعم / لا)",
        p_l_n_voltage:"P / L-N الجهد",
        n_e_voltage:"N-E الجهد",
        number_of_lamps_pole:"عدد المصابيح / العمود",
        ilm_or_glm:"ILM أو GLM",
        pole_infrastructure_improvement_is_required:"مطلوب تحسين البنية التحتية للقطب (y / n)",
        allow_to_capture_multipe_images_pole_existing_lamp:"السماح بالتقاط صور متعددة العمود والمصباح الموجود",
        existing_type_of_load:"نوع التحميل الحالي",
        wattage_of_existing_load:"القوة الكهربائية للحمل الحالي",
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذا العمود؟",
        nominal_existing_load_wattage_for_energy_savings:"القوة الكهربائية الحالية للحمل الاسمي لتوفير الطاقة",
        poles:"أعمدة"
    }
}
